import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSupportStaffDetailGet } from '@/entities/support-staff/modules/api/support-staff';

export const useSupportStaffDetail = (id: string) =>
  useFetch({
    api: () => apiSupportStaffDetailGet(id),
    keywords: queryKeys.supportStaff.detail(id),
    enabled: Boolean(id),
    staleTime: 60_000,
  });
